// hooks/useInitialFormTrigger.ts
import { useEffect } from 'react';

interface InitialTriggerParams {
  formMethods: { trigger: () => void };
  addressFields: {
    line1?: string;
    line2?: string;
    postalCode?: string;
    state?: string;
    city?: string;
    country?: string;
  };
}

export const useInitialFormTrigger = ({ formMethods, addressFields }: InitialTriggerParams) => {
  useEffect(() => {
    const { line1, line2, postalCode, state, city, country } = addressFields;
    if (line1 && line2 && postalCode && state && city && country) {
      formMethods.trigger();
    }
  }, []); // run only on mount
};
